import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import Select from "react-select";
import { validateMin } from "../../../../utils/validateMin";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

const accountingAccountOptions: any = [];
for (let i = 1; i <= 8; i++) {
  accountingAccountOptions.push({ value: i, label: i });
}

export const AddRates = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [seasonId, setSeasonId] = useState<string>("");
  const [vehicleClassId, setVehicleClassId] = useState<string>("");
  const [hourlyRate, setHourlyRate] = useState<number>(0);
  const [weeklyRate, setWeeklyRate] = useState<number>(0);
  const [dailyRate, setDailyRate] = useState<number>(0);
  const [monthlyRate, setMonthlyRate] = useState<number>(0);
  const [decreasingRateBasedOnIntervalPerHour, setDecreasingRateBasedOnIntervalPerHour] = useState<string>("Yes");
  const [decreasingRateBasedOnIntervalPerDay, setDecreasingRateBasedOnIntervalPerDay] = useState<string>("Yes");
  const [seasonOptions, setSeasonOptions] = useState([]);
  const [vehicleClassOptions, setVehicleClassOptions] = useState([]);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

  useEffect(() => {
    axios
      .get(`${baseURL}season`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setSeasonOptions(() =>
          response?.data?.map((item: any) => {
            return { value: item.id, label: item.name };
          })
        );

        setSeasonId(response?.data[0]?.id || "");
        handleTenantError(null);
      })
      .catch((error) => {
        setSeasonId("");
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}vehicleClass`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setVehicleClassOptions(() =>
          response?.data?.map((item: any) => {
            return { value: item.id, label: item.name };
          })
        );

        setVehicleClassId(response?.data[0]?.id || "");
        handleTenantError(null);
      })
      .catch((error) => {
        setVehicleClassId("");
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setPleaseWaitPopup(true);
    e.preventDefault();

    await axios
      .post(
        `${baseURL}rate?userId=${auth?.id}`,
        JSON.stringify({
          seasonId,
          vehicleClassId,
          hourlyRate,
          weeklyRate,
          monthilyRate: monthlyRate,
          dailyRate,
          decreasingRateBasedOnIntervalPerHour: decreasingRateBasedOnIntervalPerHour === "Yes",
          decreasingRateBasedOnIntervalPerDay: decreasingRateBasedOnIntervalPerDay === "Yes"
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };


  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Rate</h2>
                </div>
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <div className="grid grid-cols-3 gap-6">

                      {/* First Column */}
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Season</label>
                          <Select
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                                borderRadius: '8px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                "&: hover": {
                                  borderColor: "#167AC3",
                                }

                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                              }),
                              option: (base, state) => {
                                const isSelected = state.isSelected;
                                const isFocused = state.isFocused;
                                const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                return {
                                  ...base,
                                  backgroundColor: isSelected
                                    ? selectedBg
                                    : isFocused
                                      ? hoverBg
                                      : "transparent",
                                  color: isSelected ? "#fff" : defaultTextColor,
                                  fontWeight: 600,
                                  ':active': {
                                    backgroundColor: isSelected ? selectedBg : hoverBg,
                                  },
                                };
                              },
                              input: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,

                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,
                              }),
                            }}
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={false}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                            name="season"
                            value={seasonOptions.find(
                              (item: any) => item.value === seasonId
                            )}
                            onChange={(season: any) =>
                              setSeasonId(
                                season ? season.value : ""
                              )
                            }
                            options={seasonOptions}
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Class</label>
                          <Select
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                                borderRadius: '8px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                "&: hover": {
                                  borderColor: "#167AC3",
                                }

                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                              }),
                              option: (base, state) => {
                                const isSelected = state.isSelected;
                                const isFocused = state.isFocused;
                                const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                return {
                                  ...base,
                                  backgroundColor: isSelected
                                    ? selectedBg
                                    : isFocused
                                      ? hoverBg
                                      : "transparent",
                                  color: isSelected ? "#fff" : defaultTextColor,
                                  fontWeight: 600,
                                  ':active': {
                                    backgroundColor: isSelected ? selectedBg : hoverBg,
                                  },
                                };
                              },
                              input: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,

                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,
                              }),
                            }}
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={false}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                            name="vehicle"
                            value={vehicleClassOptions.find(
                              (item: any) => item.value === parseInt(vehicleClassId)
                            )}
                            onChange={(vehicle: any) =>
                              setVehicleClassId(vehicle ? vehicle.value : "")
                            }
                            options={vehicleClassOptions}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div className="mt-4">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Decreasing Rate Based on Interval (Per Hour)</label>
                          <RadioGroup
                            row
                            value={decreasingRateBasedOnIntervalPerHour}
                            onChange={(e) => setDecreasingRateBasedOnIntervalPerHour(e.target.value)}
                          >
                            <FormControlLabel

                              value="Yes" control=
                              {<Radio
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": {
                                    color: "blue",
                                  },
                                }}
                              />} label="Yes"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />
                            <FormControlLabel value="No" control={
                              <Radio
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": {
                                    color: "blue",
                                  },
                                }}
                              />} label="No"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />
                          </RadioGroup>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div className="mt-4">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Decreasing Rate Based on Interval (Per Day)</label>
                          <RadioGroup
                            row
                            value={decreasingRateBasedOnIntervalPerDay}
                            onChange={(e) => setDecreasingRateBasedOnIntervalPerDay(e.target.value)}
                          >
                            <FormControlLabel

                              value="Yes" control=
                              {<Radio
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": {
                                    color: "blue",
                                  },
                                }}
                              />} label="Yes"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />
                            <FormControlLabel value="No" control={
                              <Radio
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": {
                                    color: "blue",
                                  },
                                }}
                              />} label="No"
                              sx={{
                                color: themeStyles.form.labelTextColor
                              }}
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Hourly Rate ($)</label>
                          <input
                            type="number"
                            min={0}
                            step={0.01}
                            name="hourlyRate"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={hourlyRate}
                            onChange={(e) => setHourlyRate(validateMin(e.target.value, 0))}
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Daily Rate ($)</label>
                          <input
                            type="number"
                            min={0}
                            step={0.01}
                            name="dailyRate"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={dailyRate}
                            onChange={(e) => setDailyRate(validateMin(e.target.value, 0))}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Weekly Rate ($)</label>
                          <input
                            type="number"
                            min={0}
                            step={0.01}
                            name="weeklyRate"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={weeklyRate}
                            onChange={(e) => setWeeklyRate(validateMin(e.target.value, 0))}
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Monthly Rate ($)</label>
                          <input
                            type="number"
                            min={0}
                            step={0.01}
                            name="monthlyRate"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={monthlyRate}
                            onChange={(e) => setMonthlyRate(validateMin(e.target.value, 0))}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-4 mt-6">
                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.main.bg
                        }}
                        type="submit">
                        Save
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}>
                        Cancel
                      </Button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}